import {Navigate,useLocation} from "react-router-dom"
import useAuth from "./useAuth"

const RequiredAuth = ({children})=>{
    const location = useLocation()
    const {token} = useAuth()
 
    if(!token) return <Navigate to="/login" state={{from:location}} replace/>
 
    return children
 }
 
 export default RequiredAuth